import React from 'react';
import { X } from 'lucide-react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ExpirationFilterPanel = ({
  selectedStatus,
  selectedDocumentType,
  selectedDepartment,
  onStatusChange,
  onDocumentTypeChange,
  onDepartmentChange,
  onClose
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'expired', label: 'Expired' },
    { value: 'critical', label: 'Critical (≤7 days)' },
    { value: 'warning', label: 'Warning (≤14 days)' },
    { value: 'upcoming', label: 'Upcoming (≤30 days)' },
    { value: 'valid', label: 'Valid' }
  ];

  const documentTypeOptions = [
    { value: 'all', label: 'All Document Types' },
    { value: 'work_permit', label: 'Work Permit' },
    { value: 'visa', label: 'Visa' },
    { value: 'driver_license', label: 'Driver License' },
    { value: 'passport', label: 'Passport' }
  ];

  const departmentOptions = [
    { value: 'all', label: 'All Departments' },
    { value: 'HR', label: 'HR' },
    { value: 'Finance', label: 'Finance' },
    { value: 'IT', label: 'IT' },
    { value: 'Operations', label: 'Operations' },
    { value: 'Sales', label: 'Sales' }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <X className="h-5 w-5" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Expiration Status
          </label>
          <Select
            value={selectedStatus}
            onChange={(e) => onStatusChange(e?.target?.value)}
            options={statusOptions}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Document Type
          </label>
          <Select
            value={selectedDocumentType}
            onChange={(e) => onDocumentTypeChange(e?.target?.value)}
            options={documentTypeOptions}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Department
          </label>
          <Select
            value={selectedDepartment}
            onChange={(e) => onDepartmentChange(e?.target?.value)}
            options={departmentOptions}
          />
        </div>
      </div>

      <div className="mt-4 flex items-center justify-end space-x-3">
        <Button
          onClick={() => {
            onStatusChange('all');
            onDocumentTypeChange('all');
            onDepartmentChange('all');
          }}
          variant="outline"
        >
          Clear Filters
        </Button>
      </div>
    </div>
  );
};

export default ExpirationFilterPanel;